export default "__VITE_ASSET__bVL5ctHu__"